import { APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from "shared-library";

export const SIDENAV_DATA_MODULES = {theme:'Theme', entity:'Entity', pages:'Pages',api:'API', settings:'Settings', publish:'Publish', metrics:'Metrics', dataDownload:'Data', verified:'Verified',policy:'Policy',media:'Media'};
export const SIDENAV_DATA = ['Theme', 'Entity', 'Pages','Api', 'Settings', 'Publish', 'Metrics', 'Data', 'Verified','Policy','Media'];

 const appPermissions = APP_BUILDER_PERMISSIONS;
 const permissionsActions = PERMISSIONS_ACTIONS;

export const SIDENAVA_META = [
  {
    label: SIDENAV_DATA_MODULES.theme,
    icon: 'mdi-palette',
    link: '',
    permission: appPermissions.themes,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.pages,
    icon: 'mdi-window-restore',
    link: '',
    permission: appPermissions.viewPages,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.entity,
    icon: 'mdi-database',
    link: '',
    permission: appPermissions.entities,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.api,
    icon: 'mdi-api',
    link: '',
    permission: appPermissions.customApis,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.settings,
    icon: 'mdi-cog',
    link: '',
    permission: appPermissions.appSettings,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.metrics,
    icon: 'mdi mdi-chart-arc',
    link: '',
    permission: appPermissions.metrics,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.dataDownload,
    icon: 'mdi-database-arrow-down',
    link: '',
    permission: appPermissions.viewData,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.policy,
    icon: 'mdi mdi-shield-account',
    link: '',
    permission: appPermissions.policy,
    permissionAction: permissionsActions.read
  }, {
    label: SIDENAV_DATA_MODULES.media,
    icon: 'mdi mdi-image-multiple',
    link: '',
    permission: appPermissions.media,
    permissionAction: permissionsActions.read
  }
]

export const WIDGET_CLICK_ACTIONS = {
  submit: "Api-trigger",
  navigation : "navigation",
  conditionalNavigation : "subform",
  lineItem: "lineItem",
  workFlow: "workFlow",
  conditionalWorkflow: 'conditionalWorkflow',
  request:"request",
}

export const WIDGET_CLICK_ACTIONS_LABEL = {
  'Api-trigger':'submit',
  navigation : 'navigation',
  subform:'conditional navigation',
  lineItem: "line item",
  workFlow: "workflow",
  conditionalWorkflow: 'conditional workflow',
  request:"request",
}

export const WIDGET_ACTIONS = [
  { label: 'submit', action: WIDGET_CLICK_ACTIONS.submit },
  { label: 'navigation', action: WIDGET_CLICK_ACTIONS.navigation },
  { label: 'conditional navigation', action: WIDGET_CLICK_ACTIONS.conditionalNavigation },
  { label: 'line item', action: WIDGET_CLICK_ACTIONS.lineItem },
  { label: 'workflow', action: WIDGET_CLICK_ACTIONS.workFlow },
  { label: 'conditional workflow', action: WIDGET_CLICK_ACTIONS.conditionalWorkflow },
  {label:'request',action:WIDGET_CLICK_ACTIONS.request},
];



/**When adding a new widget also update WIDGET_ACTIONS_VALIDATIONS with widget type and related actions and validations */
export const WIDGET_TYPES = {
  textbox: 'textbox',
  address: 'address',
  numeric_textbox: 'numeric_textbox',
  image: 'image',
  date: 'date',
  singleselectcheckbox: 'singleselectcheckbox',
  radio: 'radio',
  button: 'button',
  separator: 'separator',
  tabs: 'tabs',
  geotag: 'geotag',
  geofence : 'geofence',
  preview_group: 'preview_group',
  scanner: 'scanner',
  time_preview: 'time_preview',
  datalist: 'DataList',
  dropdown: 'dropdown',
  filePicker:'filepicker',
  plainText:'text',
  searchableDropdown:'searchableDropdown',
  imageUploader:'imageUploader',
  navButton: 'NavButton',
  navText: 'NavText',
  faceId:'faceId',
  fingerPrint:'fingerPrint',
  printer:'printer',
  barChart: 'barChart',
  lineChart: 'lineChart',
  pieChart: 'pieChart',
  donutChart:'donutChart',
  stackBarChart: 'stackBarChart',
  fixedBarChart : 'fixedBarChart',
  map: 'map',
  chatView:'chatView',
  chatBot: 'chatBot',
  dataBoard:'dataBoard',
  overviewTracker:'overviewTracker',
  filter:'filter',
};

export const WIDGET_ACTIONS_VALIDATIONS : {
  [key: string]: {action:string[],validation:string[]};
} = {
  textbox: {action:[],validation:['Required', 'Minimum Length', 'Maximum Length', 'Regular Expression']},
  address: {action:[],validation:['Required']},
  numeric_textbox: {action:[],validation:[]},
  image: {action:[],validation:['Required']},
  date: {action:[],validation:['Required']},
  singleselectcheckbox: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ],validation:['Required']},
  radio: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ],validation:['Required']},
  button: {action:[WIDGET_CLICK_ACTIONS.submit,WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ,  WIDGET_CLICK_ACTIONS.lineItem ,  WIDGET_CLICK_ACTIONS.workFlow, WIDGET_CLICK_ACTIONS.conditionalWorkflow,WIDGET_CLICK_ACTIONS.request],validation:[]},
  separator: {action:[],validation:[]},
  tabs: {action:[],validation:[]},
  geotag: {action:[],validation:['Required']},
  geofence: {action:[],validation:['Required']},
  preview_group: {action:[],validation:[]},
  scanner: {action:[],validation:['Required']},
  time_preview: {action:[],validation:[]},
  DataList: {action:[],validation:[]},
  dropdown: {action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ],validation:['Required']},
  filepicker:{action:[],validation:['Required']},
  text:{action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ],validation:[]},
  searchableDropdown:{action:[],validation:[]},
  imageUploader:{action:[WIDGET_CLICK_ACTIONS.navigation,WIDGET_CLICK_ACTIONS.conditionalNavigation ],validation:[]},
  NavButton:{action:[WIDGET_CLICK_ACTIONS.navigation],validation:[]},
  NavText: {action:[],validation:[]},
  faceId:{action:[],validation:[]},
  fingerPrint:{action:[],validation:[]},
  printer:{action:[WIDGET_CLICK_ACTIONS.submit,WIDGET_CLICK_ACTIONS.navigation],validation:[]},
  barChart:{action:[],validation:[]},
  lineChart:{action:[],validation:[]},
  pieChart:{action:[],validation:[]},
  donutChart:{action:[],validation:[]},
  stackBarChart:{action:[],validation:[]},
  fixedBarChart : {action:[],validation:[]},
  map:{action:[],validation:[]},
  chatView:{action:[],validation:[]},
  chatBot:{action:[],validation:[]},
  dataBoard:{action:[WIDGET_CLICK_ACTIONS.navigation],validation:[]},
  overviewTracker:{action:[],validation:[]},
  filter:{action:[],validation:[]},
};

export const DISPLAY_WIDGETS = [WIDGET_TYPES.datalist,WIDGET_TYPES.dataBoard,WIDGET_TYPES.overviewTracker,WIDGET_TYPES.barChart,WIDGET_TYPES.lineChart,WIDGET_TYPES.pieChart,WIDGET_TYPES.donutChart,WIDGET_TYPES.stackBarChart,WIDGET_TYPES.fixedBarChart]

export const PAGE_TYPE_MAPPING = {
  LoginPage: {
    Default: 'default-login-page',
    // 'Face ID': 'face-id-page',
    // OTP: 'otp-page',
    // Fingerprint: 'touch-id-page',
  },
  // ForgotPasswordPage: {
  //   Default: 'forgot-password-page',
  // },
  // ChangePasswordPage: {
  //   Default: 'change-password-page',
  // },
}

export const ICON_TYPES = {
  menu: 1,
  arrow_back: 2,
  arrow_forward: 3,
  home: 4,
  notifications: 5,
  logout: 6,
  sync: 7,
  noIcon: 8,
  message: 9,
  save:10
};

export const DEFAULT_BLANK_PAGE = {
  "pageType": "CustomPage",
  "items": [{
    "masterPageName":"Blank Page",
    "icon": "forgot-password-page",
    "pageType": "CustomPage"
  }]
}
export const LAST_SELECTED_OPTION = 'lastSelectedOption';

export const pageTypeCnsts = {
  LOGIN: 'LoginPage',
  SPLASH_SCREEN: 'SplashScreenPage',
  PREVIEW: 'PreviewPage',
  COMPONENTS: 'components',
  SECTION: 'section',
  MENU_PANEL: 'menuPanel',
  DATA_LIST_VIEW: 'dataListView',
};

export const REMOVE_ITEM_FROM_WIDGET_LIST = [WIDGET_TYPES.filePicker, WIDGET_TYPES.image, WIDGET_TYPES.singleselectcheckbox, WIDGET_TYPES.geofence, WIDGET_TYPES.geotag, WIDGET_TYPES.barChart, WIDGET_TYPES.donutChart, WIDGET_TYPES.lineChart, WIDGET_TYPES.stackBarChart, WIDGET_TYPES.pieChart,WIDGET_TYPES.fixedBarChart];


export const ALLOWED_ITEM_FROM_WIDGET_LIST = [WIDGET_TYPES.dropdown,WIDGET_TYPES.address,WIDGET_TYPES.date,WIDGET_TYPES.textbox,WIDGET_TYPES.singleselectcheckbox,WIDGET_TYPES.radio,WIDGET_TYPES.scanner];

export const ALLOWED_ITEM_FROM_WIDGET_LIST_FOR_DATALISTPAGE = [WIDGET_TYPES.dropdown,WIDGET_TYPES.address,WIDGET_TYPES.date,WIDGET_TYPES.geofence,WIDGET_TYPES.geotag,WIDGET_TYPES.textbox,WIDGET_TYPES.plainText,WIDGET_TYPES.image,WIDGET_TYPES.filePicker,WIDGET_TYPES.singleselectcheckbox,WIDGET_TYPES.radio,WIDGET_TYPES.scanner,WIDGET_TYPES.button];

export const Default_Pages={
  "LandingPage":"LandingPage",
  "SplashScreenPage":"SplashScreenPage",
  "LoginPage":"LoginPage",
}

export const VALIDATIONS = {
  required: 'Required',
  maximum_length: 'Maximum Length',
  minimum_length: 'Minimum Length',
  start_date: 'Start Date',
  end_date: 'End Date',
  regex: 'Regular Expression',
  formValidation:'Form Validation'
}

export const PAGETYPES = {
  splashScreen: 'SplashScreenPage',
  loginPage: 'LoginPage',
  landingPage: 'LandingPage',
  customPage: 'CustomPage',
  forgetPassword: 'ForgotPasswordPage',
  changePassword: 'ChangePasswordPage',
  previewPage: 'PreviewPage',
  logout: 'Logout',
  peripherals:'Peripherals',
  dataListView:'dataListView'
}

export const WORKFLOW_STAGE_ACTION_TYPES = ["Next Stage"];

export const WORKFLOW_EVENT_TYPES = {
  click:'click',
  closed:'closed',
  update:'update',
}

export const PAGE_FORM_TYPES = {
  navbar:"Navgation Bar",
  menuPanel:"menuPanel",
  section:"section"
}

export const DROPDOWN_DATASOURCE_FILTERTYPES = {
  manual:"manual",
  widget:"widget"
}


export const ALLOWED_INPUT_WIDGET_TYPES = [WIDGET_TYPES.dropdown,WIDGET_TYPES.address,WIDGET_TYPES.date,WIDGET_TYPES.geofence,WIDGET_TYPES.geotag,WIDGET_TYPES.textbox,WIDGET_TYPES.singleselectcheckbox,WIDGET_TYPES.radio,WIDGET_TYPES.scanner]

export const ALLOWED_INPUT_WIDGET_TYPES_FOR_LINEITEM_ACTION = [WIDGET_TYPES.dropdown,WIDGET_TYPES.address,WIDGET_TYPES.date,WIDGET_TYPES.textbox,WIDGET_TYPES.singleselectcheckbox,WIDGET_TYPES.radio,WIDGET_TYPES.scanner]

export const STANDERD_ADDITIONAL_WIDGETS =  [{
        widgetId:'user_id',widgetLabel:'user Id',widgetType:'user_id'
      },
      {
        widgetId:'stage_id',widgetLabel:'stage Id',widgetType:'stage_id'
      },
      {
        widgetId:'stage_status',widgetLabel:'stage status',widgetType:'stage_status'
      }]     

